import { ValidationRule } from 'react-hook-form';
import { IFixedTermSimulation } from '../types/IFixedTermSimulation';
import { required } from '@bpba/form-components';
import { DECIMAL_NUMBER_FORMAT, INPUT_INVALID_FORMAT_MESSAGE, INTEGER_NUMBER_FORMAT, FIXED_TERM_AMOUNT_MIN, FIXED_TERM_TIME_MAX, FIXED_TERM_TIME_MIN } from '../constants/form';
import { renderAmount } from './RenderAmount';

export const FixedTermSimulatorRules: Record<string, Record<keyof IFixedTermSimulation, Record<string, ValidationRule | any>>> = {
  rules: {
    amount: {
      required,
      pattern: {
        message: INPUT_INVALID_FORMAT_MESSAGE,
        value: DECIMAL_NUMBER_FORMAT,
      },
      min: {
        message: `Mínimo ${renderAmount(FIXED_TERM_AMOUNT_MIN, '')}`,
        value: FIXED_TERM_AMOUNT_MIN,
      },
    },
    term: {
      required,
      min: {
        message: `Mínimo ${FIXED_TERM_TIME_MIN} días`,
        value: FIXED_TERM_TIME_MIN,
      },
      max: {
        message: `Máximo ${FIXED_TERM_TIME_MAX} días`,
        value: FIXED_TERM_TIME_MAX,
      },
      pattern: {
        message: INPUT_INVALID_FORMAT_MESSAGE,
        value: INTEGER_NUMBER_FORMAT,
      },
    },
  },
};
